"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStringNumeric = exports.decodeDomain = exports.encodeDomain = exports.validLibraryId = exports.extractCardId = exports.extractSetId = exports.leftPad = exports.decimalToBase52 = exports.decodeLibraryId = exports.encodeLibraryId = exports.chunkString = exports.headerCode = exports.b52ToDec = exports.decToB52 = void 0;
var anyBase = require("any-base");
var Alphabet;
(function (Alphabet) {
    Alphabet["Base10"] = "0123456789";
    Alphabet["Base52"] = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
})(Alphabet || (Alphabet = {}));
var GuDomainMap = {
    death: 1,
    deception: 2,
    light: 3,
    magic: 4,
    nature: 5,
    war: 6,
};
exports.decToB52 = anyBase(Alphabet.Base10, Alphabet.Base52);
exports.b52ToDec = anyBase(Alphabet.Base52, Alphabet.Base10);
exports.headerCode = "GU";
function chunkString(source, size) {
    return source.match(new RegExp(".{1," + size + "}", "g"));
}
exports.chunkString = chunkString;
/**
 *
 * @param librayId string of form LX-XXX
 * L - Library ID prefix (like art IDs have C, B, T, etc)
 * X - Set ID. Core is 1, Genesis is 2, etc.
 * XXX - ID of card in set.
 */
function encodeLibraryId(librayId) {
    if (!validLibraryId(librayId)) {
        throw new Error("Library ID is not valid.");
    }
    var setIdBase52 = decimalToBase52(extractSetId(librayId));
    var cardIdBase52 = decimalToBase52(extractCardId(librayId));
    return "" + setIdBase52 + leftPad(cardIdBase52);
}
exports.encodeLibraryId = encodeLibraryId;
/**
 *
 * @param encodedLibraryId
 */
function decodeLibraryId(encodedLibraryId) {
    var setIdBased52 = encodedLibraryId.slice(0, 1);
    var cardIdBase52 = encodedLibraryId.slice(1);
    var setId = exports.b52ToDec(setIdBased52);
    var cardId = exports.b52ToDec(cardIdBase52);
    return "L" + setId + "-" + leftPad(cardId, "0", 3);
}
exports.decodeLibraryId = decodeLibraryId;
function decimalToBase52(decimal) {
    return exports.decToB52(decimal);
}
exports.decimalToBase52 = decimalToBase52;
function leftPad(source, padding, length) {
    if (padding === void 0) { padding = "A"; }
    if (length === void 0) { length = 2; }
    while (source.length < length) {
        source = "" + padding + source;
    }
    return source;
}
exports.leftPad = leftPad;
/**
 * Returns the setId (X) from a  valid libraryId (LX-xxx)
 * @param libraryId a valid libraryId
 */
function extractSetId(libraryId) {
    var prefix = libraryId.split("-")[0];
    return prefix.slice(1);
}
exports.extractSetId = extractSetId;
/**
 * Returns the cardId (xxx) from a  valid libraryId (LX-xxx)
 * @param libraryId a valid libraryId
 */
function extractCardId(libraryId) {
    var _a = libraryId.split("-"), prefix = _a[0], cardId = _a[1];
    return cardId;
}
exports.extractCardId = extractCardId;
/**
 * Returns true if the libraryId is valid (i.e LX-XXX).
 * @param libraryId
 */
function validLibraryId(libraryId) {
    if (!libraryId || libraryId.length < 6) {
        return false;
    }
    var _a = libraryId.split("-"), prefix = _a[0], cardId = _a[1], rest = _a.slice(2);
    if (!prefix || !cardId || rest.length) {
        return false;
    }
    if (prefix[0] !== "L") {
        return false;
    }
    var setId = prefix.slice(1);
    for (var _i = 0, setId_1 = setId; _i < setId_1.length; _i++) {
        var c = setId_1[_i];
        if (Alphabet.Base10.indexOf(c) === -1) {
            return false;
        }
    }
    if (cardId.length < 3) {
        return false;
    }
    for (var _b = 0, cardId_1 = cardId; _b < cardId_1.length; _b++) {
        var c = cardId_1[_b];
        if (Alphabet.Base10.indexOf(c) === -1) {
            return false;
        }
    }
    return true;
}
exports.validLibraryId = validLibraryId;
function encodeDomain(domain) {
    var result = GuDomainMap[domain];
    if (!result) {
        throw new Error("Invalid domain.");
    }
    return result;
}
exports.encodeDomain = encodeDomain;
function decodeDomain(domainCode) {
    for (var _i = 0, _a = Object.entries(GuDomainMap); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (domainCode === value) {
            return key;
        }
    }
    throw new Error("Invalid domainCode.");
}
exports.decodeDomain = decodeDomain;
function isStringNumeric(source) {
    for (var _i = 0, source_1 = source; _i < source_1.length; _i++) {
        var c = source_1[_i];
        if (Alphabet.Base10.indexOf(c) === -1) {
            return false;
        }
    }
    return true;
}
exports.isStringNumeric = isStringNumeric;
